import React from 'react';
import { graphql } from "gatsby";
import Masonry from 'react-masonry-css'
import Tile from '../../components/tile/tile';
import ModuleWrapper from '../../globals/moduleWrapper/moduleWrapper';
import {BreakPtMobile, BreakPtTablet, BreakPtDesktop} from '../../assets/sass/export.module.scss';

/**
 * CMS Component: DatoCmsModuleTile
 * 
 */
const Tiles = ({data, className, insertData, insertIndex, numToDisplay, ...other}) => {
  const {anchor, border, tiles} = data || {}; 
  //Create a copy of the tiles array for mutation
  let newTiles = [...tiles];
  
  //add insert data
  if(insertData){
    newTiles.splice(((insertIndex || 0) + 1 ), 0, insertData)
  }

  const breakpointColumnsObj = {
    default: 3,
    [BreakPtDesktop]: 3,
    [BreakPtTablet]: 2,
    [BreakPtMobile]: 1
  };

  return (
    <ModuleWrapper anchor={anchor} border={border} className={`tiles ${className || ''}`} {...other}>
        {
          newTiles && 
          <Masonry breakpointCols={breakpointColumnsObj} className="tiles__masonry" columnClassName="tiles__masonry__col" >
            {
              newTiles?.map((tile, i)=> {
                return (i < numToDisplay || !numToDisplay) &&  <Tile data={tile} key={i} />   
              })
            }
          </Masonry>
        }
    </ModuleWrapper>
  );
};

export default Tiles;

export const ModuleTilesFragment = graphql`
fragment ModuleTilesFragment on DatoCmsModuleTile {
  moduleID: id
  anchor
  border
  tiles{
    ...TileFragment
  }
  toggleId
}
`;